import React from "react";
import {TEXT_TYPES} from "../../../constants/APP_CONSTANTS";
import urlHelper from "../../../_helpers/url.format.helper";
import config from "../../../config";
import AxiosClient from "../../../_helpers/http.helper";
import union from "lodash/union";
import InfiniteScroll from "react-infinite-scroll-component";
import LoadingIndicator from "../../widgets/LoadingIndicator/LoadingIndicator";
import ReactTable from "react-table";
import moment from "moment";

export default class ContentUpdateStatus extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            metadataUpdateBatches: [],
            pageSize: 25,
            pageNumber: null,
            totalItems: 0,
            hasMore: true,
            selectedBatchId: null,
            statusesList: {},
            selectedBatch: {},
            activeActionCards: [],
            isLoading: true
        };
    }

    componentDidMount() {
        this.loadMore();
    }

    loadMore = () => {
        if (!this.state.hasMore) {
            return;
        }

        const url = urlHelper.formatUrl(
            config.contentService.baseUrl,
            config.contentService.routes.getContentBatches,
            {
                pageSize: this.state.pageSize,
                pageNumber:
                    this.state.pageNumber === null
                        ? 0
                        : this.state.pageNumber + 1
            }
        );
        AxiosClient.get(url).then(response => {
                       const userList = this.createUserIdpayload(response.data.content);
            return {userList, response};
        }).then(result => {
            const {userList, response} = result;
            this.getUserList(userList).then((userInfo) => {
                const userMap = this.createAnUserHashMap(userInfo.data);

                response.data.content.map(batch => {
                    batch.creator = userMap[batch.creator];
                });

            const results = response.data;

            this.setState(prevState => ({
                metadataUpdateBatches: union([
                    ...prevState.metadataUpdateBatches,
                    ...results.content
                ], 'batchId'),
                pageNumber: results.number,
                totalItems: results.totalElements,
                hasMore: !results.last,
                isLoading: false
            }));
        });
    });
};

    createUserIdpayload = (batches) => {
        const userList = [];
        batches.map(batch => {
            if (!userList.includes(batch.creator)) {
                userList.push(batch.creator);
            }
        });
        return userList;
    };

    getUserList = (payload) => {
        const url = urlHelper.formatUrl(
            config.identity.baseUrl,
            config.identity.routes.getUsersList);
        return AxiosClient.post(url, payload);
    };

    createAnUserHashMap = (userInfoList) => {
        let userMap = {};
        userInfoList.map(user => {
            userMap = {
                ...userMap,
                [user.id]: user.firstName+" "+user.lastName
            };
        });
        return userMap;
    };


    hasMore = () => {
        this.setState({
            hasMore: false
        });
    };

    generateStatusesList = selectedBatchId => {
        const selectedBatch = this.state.metadataUpdateBatches.find(
            item => item.batchId === selectedBatchId
        );

        this.setState({
            selectedBatch: selectedBatch,
            selectedBatchId,
        });
    };

    renderActionCards = () => (
        <div className={`action-card-${this.state.selectedBatch.ingestionStatusType}`}>
            <br/>
            {Object.keys(this.state.selectedBatch).length > 0 && 
            (
                            <div>
                                <table className="pe-table mb-0">
                                    <thead>
                                        <tr>
                                            <th scope="col">File Name</th>
                                            <th scope="col">Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            <tr>
                                                <td>{this.state.selectedBatch.fileName}</td>
                                                <td>{this.state.selectedBatch.ingestionStatusType}</td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        
                   
                )
            }
        </div>
    );

    render() {
        const columns = [
            {
                Header: "Batch ID",
                accessor: "batchId",
                sortable: true,
            },
            {
                Header: "Upload Date",
                id: "creationDate",
                width: 150,
                accessor: d =>
                    moment(d.creationDate)
                        .utc()
                        .format("MM/DD/YY HH:mm z"),
                sortable: true
            },
            {
                Header: "Creator",
                accessor: "creator",
                sortable: true
            }
        ];

        return (
            <div className="content-home-page metadata-update-status">
                <div>
                    <label className="pe-page-title--small">
                        {TEXT_TYPES.CONTENT_UPDATE_STATUS}
                    </label>
                    <hr />{this.state.totalItems > 0 && <h3> Total batches: {this.state.totalItems}</h3> }
                </div> {this.state.isLoading && <LoadingIndicator/>}
                <div className="pe-row">
                    <div className="pe-col-6 pt-4">
                         {this.state.totalItems > 0 && (
                            <div id="scrollTable" className="infiniteScroll">
                                <InfiniteScroll
                                    dataLength={
                                        this.state.metadataUpdateBatches
                                            .length
                                    }
                                    next={this.loadMore}
                                    hasMore={this.state.hasMore}
                                    loader={<LoadingIndicator />}
                                    scrollableTarget="scrollTable"
                                >
                                    <div className="table-wrap">
                                        <ReactTable
                                            className="-highlight"
                                            data={
                                                this.state
                                                    .metadataUpdateBatches
                                            }
                                            showPagination={false}
                                            columns={columns}
                                            defaultPageSize={
                                                this.state.totalItems
                                            }
                                            minRows={0}
                                            sortable={false}
                                            pageText=""
                                            noDataText="No Batches found"
                                            getTrProps={(_, rowInfo) => {
                                                const selectedBatchId = rowInfo.original.batchId;
                                                return {
                                                    style: {
                                                        textAlign: "center",
                                                        cursor: "pointer"
                                                    },
                                                    onClick: () => this.generateStatusesList(selectedBatchId)
                                                };
                                            }}
                                        />
                                    </div>
                                </InfiniteScroll>
                            </div>
                        )}
                    </div>
                    <div className="pe-col-4">{this.renderActionCards()}</div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/ContentManagement/ContentUpdateStatus.js